import React from "react";
import classNames from "classnames";
import { Button } from "@campgladiator/cgui-core.atoms.button";
import { Card } from "@campgladiator/cgui-core.atoms.card";
import { Icon } from "@campgladiator/cgui-core.atoms.icon";
import { Paragraph } from "@campgladiator/cgui-core.atoms.typography";
import styles from "./growl-message.module.scss";

type ButtonProps = {
  onClick: () => void;
  text: string;
};

export type GrowlMessageProps = {
  autoClose?: boolean;
  button?: ButtonProps;
  children: React.ReactNode;
  isVisible: boolean;
  onClick: () => void;
  title?: string;
};

const GrowlMessage = ({
  autoClose = true,
  button = {
    onClick: () => {},
    text: "",
  },
  children,
  isVisible,
  onClick,
  title = "",
}: GrowlMessageProps) => {
  autoClose &&
    setTimeout(() => {
      isVisible && onClick();
    }, 6000);

  return (
    <>
      <Card
        className={classNames(styles.growlMessage, {
          [styles.open]: isVisible,
        })}
      >
        <div className={styles.content}>
          {title && (
            <Paragraph size="small" weight="bold" className={styles.title}>
              {title}
            </Paragraph>
          )}
          <Paragraph size="small" weight="book" className={styles.description}>
            {children}
          </Paragraph>
        </div>
        {button.text && (
          <div className={styles.action}>
            <Button
              onClick={button.onClick}
              size="small"
              variation="outline"
              emphasis="negative"
            >
              {button.text}
            </Button>
          </div>
        )}
        <div className={styles.close}>
          <Icon.Line name="icon-times" onClick={onClick} />
        </div>
      </Card>
    </>
  );
};

export default GrowlMessage;
